module.exports = __webpack_public_path__ + "img/car_08.09d479b6.jpg";